import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-health-check-error-dialog',
  imports: [TranslatePipe],
  templateUrl: './health-check-error-dialog.html',
  styleUrl: './health-check-error-dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HealthCheckErrorDialogComponent {
  protected reload(): void {
    location.reload();
  }
}
